import { SingleSpaCustomEventDetail } from "single-spa";
import { IAuthenticator } from "../authentication/authenticator";
import Router, { IRouter } from "./router";
import { SingleSpa } from "./single-spa";
import { Startup } from "./startup";
import { IAppSettings } from "../configuration/appsettings";
import { User } from "../authentication/user";
import { Gtm } from "../gtm/gtm";

export const bootstrap = async (
  authenticator: IAuthenticator,
  appSettings: IAppSettings
) => {
  const user = new User(authenticator);

  const router = new Router(appSettings);

  const gtm = new Gtm();

  const startup = new Startup(
    authenticator,
    user,
    router,
    new SingleSpa(),
    gtm
  );

  const userIsLoaded = await startup.run();

  window.addEventListener(
    "single-spa:before-routing-event",
    ({
      detail: { newUrl, cancelNavigation },
    }: SingleSpaCustomEventDetail | any) => {
      const pathname = new URL(newUrl).pathname;
      if (router.canVisit(pathname)) {
        if (pathname != "/" && !userIsLoaded) {
          cancelNavigation();
          authenticator.loginAsync().catch((error) => console.error(error));
        }
      } else {
        router.redirectToLegacy();
      }
    }
  );
};
